import { Loading } from "@omnijus/common";
import DownloadIcon from "../../../../assets/images/download-icon.svg";
import { ActionFeedback } from "@omnijus/common";
import React, { useEffect, useState } from "react";
import { MovimentoProcesso } from "../../../../services/processo/models/movimento-processo";
import { ProcessoDetalheService } from "../../../../services/processo/processo-detalhe-service";
import { ProcessoDocumentoService } from "../../../../services/processo/processo-documento-service";
import "./documentos-processo.scss";

export const DocumentosProcesso = (props: { idProcesso: string }) => {
    const [promise, setPromise] = useState<Promise<MovimentoProcesso[] | undefined>>();
    const [nDocumentos, setNDocumentos] = useState(0);

    useEffect(() => {
        setPromise(
            ProcessoDetalheService.getMovimentos(props.idProcesso, true).then((res) => {
                setNDocumentos(res?.length || 0);
                return res;
            })
        );
    }, [props.idProcesso]);

    const downloadFileMovimento = async (idProcessoMovimento: string, filename: string) => {
        await ActionFeedback.processing({
            title: "Gerando arquivo para download",
            execution: ProcessoDetalheService.downloadMovimento(props.idProcesso, idProcessoMovimento, filename),
        });
    };

    const downloadFileProcesso = async (filename: string) => {
        await ActionFeedback.processing({
            title: "Gerando arquivo para download",
            execution: ProcessoDocumentoService.downloadArquivosProcesso(props.idProcesso, filename),
        });
    };

    return (
        <div className="card-processo-detalhe documentos-processo">
            <header>
                <h3>Documentos do processo</h3>
                {nDocumentos > 0 ? (
                    <button onClick={() => downloadFileProcesso(`${props.idProcesso}.zip`)}>
                        <img className="download-icon" alt="Ícone de download" src={DownloadIcon} />
                    </button>
                ) : (
                    <></>
                )}
            </header>
            <Loading promise={promise}>
                {(movimentos) => {
                    if (movimentos) {
                        return (
                            <div className="card-body-scrollable">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Data</th>
                                            <th>Movimentação</th>
                                            <th>Fase</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {movimentos.length === 0 ? (
                                            <tr>
                                                <td className="center" colSpan={3}>
                                                    Nenhum documento.
                                                </td>
                                            </tr>
                                        ) : (
                                            movimentos.map((doc, i) => (
                                                <tr key={doc.idProcessoMovimento}>
                                                    <td className="col-data">
                                                        {new Date(doc.data).toLocaleDateString("pt-BR")}
                                                    </td>
                                                    <td>{doc.movimentacao}</td>
                                                    <td className="col-fase">{doc.fase}</td>
                                                    <td className="col-download">
                                                        <button
                                                            onClick={() =>
                                                                downloadFileMovimento(
                                                                    doc.idProcessoMovimento,
                                                                    `${doc.movimentacao}.zip`
                                                                )
                                                            }
                                                        >
                                                            <img
                                                                className="download-icon"
                                                                alt="Ícone de download"
                                                                src={DownloadIcon}
                                                            />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        );
                    } else {
                        return <></>;
                    }
                }}
            </Loading>
        </div>
    );
};
